/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Layout und Inhalte der Bedienung fuer EIN Geraet.
 * @export
 * @interface DatabaseNavigationSetting
 */
export interface DatabaseNavigationSetting {
    /**
     * Wo die Bedienung sitzt und in welcher Form. NONE = keine. Bewusst `layout` und nicht `schema`: letzteres ist im OpenAPI-Umfeld belegt.
     * DIE SIEBEN KONZEPTE stammen aus dem UX-Prototyp (tabellensteuerung_ux_protooyp_v7.html) und heissen dort: 1 Klassische Toolbar - 1b Icon-Toolbar - 2 Flyout-Seitenleiste - 3 Spalten-Pillen - 4 Zentrales Modal - 5 Floating Dock (Rand) - 6 Action Ribbon.
     * SIDEBAR / BURGER / BUTTONS sind die abgeloesten Werte. Sie stehen hier weiter, WEIL SONST BESTEHENDE DATENBANKEN NICHT MEHR LESBAR WAEREN: Jackson wirft bei einem Enum-Wert, den es nicht kennt -- anders als bei einem unbekannten FELD, das still verworfen wird. Erst wenn die Migration ueberall durch ist, duerfen sie weg.
     * @type {string}
     * @memberof DatabaseNavigationSetting
     */
    layout?: DatabaseNavigationSettingLayoutEnum;
    /**
     * Knopf "Neuer Eintrag"
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showAdd?: boolean;
    /**
     * Suchfeld
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showSearch?: boolean;
    /**
     * Im- und Export
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showImportExport?: boolean;
    /**
     * ALT -- war „Filter und Sortierung\" in einem. Seit die Sortierung in der Spaltenueberschrift sitzt, gehoeren sie getrennt: `showFilter` und `showSort`. Bleibt stehen, damit gespeicherte Einstellungen weiterlaufen -- die neuen Felder fallen darauf zurueck.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showFilterSort?: boolean;
    /**
     * Filter
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showFilter?: boolean;
    /**
     * Sortierung. In der Listenansicht sitzt sie in der Spaltenueberschrift; dieser Schalter steuert den Knopf, den Grid und Galerie brauchen -- dort gibt es keine Ueberschriften.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showSort?: boolean;
    /**
     * Gruppierung nach einem Feld. Bisher stand der Knopf immer da, ohne dass der Betreiber ihn abschalten konnte -- anders als jeder andere Befehl der Bedienung.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showGrouping?: boolean;
    /**
     * Drucken
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showPrint?: boolean;
    /**
     * Blaetterleiste (Seitenzahlen, Eintraege pro Seite)
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showPagination?: boolean;
    /**
     * Die Buchstabenleiste A-Z ueber der Uebersicht.
     * SIE STEHT NICHT IN DER KLAMMER DER FUNKTIONEN, sondern als eigene Zeile darunter (Vorgabe des Betreibers 02.10.2026: "A B C, Suche und Stichworte werden nicht in die Klammer der Funktionen aufgenommen sondern sind extra anzuzeigen"). Sie beginnt mit "Alle"; Buchstaben ohne Treffer sind blass und gesperrt.
     * JE GERAET, wie jede andere Auspraegung: Sechsundzwanzig Knoepfe sind auf dem Rechner eine Zeile und auf dem Telefon drei.
     * Fehlt der Wert, erscheint sie nicht.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showAbc?: boolean;
    /**
     * Die Stichwortleiste ueber der Uebersicht, als eigene Zeile unter der Buchstabenleiste. Sie beginnt mit "Alle Stichwoerter" und zeigt die tatsaechlich vergebenen Werte -- nicht die moeglichen.
     * Fehlt der Wert, erscheint sie nicht.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showStichworte?: boolean;
    /**
     * Knopf "Markierte loeschen". Eigener Schalter, weil die alten `_LIGHT`-Bedienformen genau diesen Knopf mit ausgeblendet haben — ohne ihn wuerde er nach der Migration bei diesen Datenbanken ploetzlich auftauchen.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showDelete?: boolean;
    /**
     * Knopf "Auswertung" (Kreuztabelle). Oeffnet einen Dialog, in dem sich eine Pivot-Tabelle zusammenstellen laesst; das Ergebnis erscheint in einem neuen Fenster mit Kopf und Fuss der Datenbank.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showAuswertung?: boolean;
    /**
     * Knopf "Mailversand". Verschickt EINE Mail-Vorlage der Datenbank an die Adressen der MARKIERTEN Datensaetze -- je Datensatz eine Mail, mit dessen eigenen Werten in den Platzhaltern.
     * Eigener Schalter und in der Vorgabe AUS: Wer ihn anbietet, gibt jedem Bearbeiter der Datenbank die Moeglichkeit, mit einem Klick hunderte Mails im Namen des Betreibers zu verschicken. Eine solche Wirkung nach aussen gehoert ausdruecklich freigegeben, nicht stillschweigend mitgeliefert.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showMailversand?: boolean;
    /**
     * Knopf "Wert setzen". Setzt bei den MARKIERTEN Datensaetzen ein Feld auf denselben Wert -- das Gegenstueck zu "Markierte loeschen", nur ohne Verlust. Gedacht fuer Zustandswechsel, die viele Datensaetze auf einmal betreffen: eine Auswahl aus dem Themenspeicher in die Planung schieben, aus der Planung in den naechsten Entwicklungs- abschnitt. Ohne ihn muss man dafuer jeden Datensatz einzeln oeffnen. Eigener Schalter, weil eine Massenaenderung nicht in jede Datenbank gehoert.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showWertSetzen?: boolean;
    /**
     * Die beiden Favoriten-Knoepfe ("Favorit auswaehlen" und "Favorit hinzufuegen"). Sie erscheinen nur, wenn die Datenbank eine Unterdatenbank hat, deren Name mit "Favoriten" beginnt -- dieser Schalter entscheidet zusaetzlich, ob der Betreiber sie anbieten will. Bis 27.08.2026 waren sie die einzigen Knoepfe der Bedienung ohne eigenen Schalter.
     * @type {boolean}
     * @memberof DatabaseNavigationSetting
     */
    showFavorites?: boolean;
}


/**
 * @export
 */
export const DatabaseNavigationSettingLayoutEnum = {
    None: 'NONE',
    Toolbar: 'TOOLBAR',
    IconToolbar: 'ICON_TOOLBAR',
    Flyout: 'FLYOUT',
    Pills: 'PILLS',
    Modal: 'MODAL',
    Dock: 'DOCK',
    Ribbon: 'RIBBON',
    Sidebar: 'SIDEBAR',
    Burger: 'BURGER',
    Buttons: 'BUTTONS'
} as const;
export type DatabaseNavigationSettingLayoutEnum = typeof DatabaseNavigationSettingLayoutEnum[keyof typeof DatabaseNavigationSettingLayoutEnum];


/**
 * Check if a given object implements the DatabaseNavigationSetting interface.
 */
export function instanceOfDatabaseNavigationSetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNavigationSettingFromJSON(json: any): DatabaseNavigationSetting {
    return DatabaseNavigationSettingFromJSONTyped(json, false);
}

export function DatabaseNavigationSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNavigationSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'layout': !exists(json, 'layout') ? undefined : json['layout'],
        'showAdd': !exists(json, 'showAdd') ? undefined : json['showAdd'],
        'showSearch': !exists(json, 'showSearch') ? undefined : json['showSearch'],
        'showImportExport': !exists(json, 'showImportExport') ? undefined : json['showImportExport'],
        'showFilterSort': !exists(json, 'showFilterSort') ? undefined : json['showFilterSort'],
        'showFilter': !exists(json, 'showFilter') ? undefined : json['showFilter'],
        'showSort': !exists(json, 'showSort') ? undefined : json['showSort'],
        'showGrouping': !exists(json, 'showGrouping') ? undefined : json['showGrouping'],
        'showPrint': !exists(json, 'showPrint') ? undefined : json['showPrint'],
        'showPagination': !exists(json, 'showPagination') ? undefined : json['showPagination'],
        'showAbc': !exists(json, 'showAbc') ? undefined : json['showAbc'],
        'showStichworte': !exists(json, 'showStichworte') ? undefined : json['showStichworte'],
        'showDelete': !exists(json, 'showDelete') ? undefined : json['showDelete'],
        'showAuswertung': !exists(json, 'showAuswertung') ? undefined : json['showAuswertung'],
        'showMailversand': !exists(json, 'showMailversand') ? undefined : json['showMailversand'],
        'showWertSetzen': !exists(json, 'showWertSetzen') ? undefined : json['showWertSetzen'],
        'showFavorites': !exists(json, 'showFavorites') ? undefined : json['showFavorites'],
    };
}

export function DatabaseNavigationSettingToJSON(value?: DatabaseNavigationSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'layout': value.layout,
        'showAdd': value.showAdd,
        'showSearch': value.showSearch,
        'showImportExport': value.showImportExport,
        'showFilterSort': value.showFilterSort,
        'showFilter': value.showFilter,
        'showSort': value.showSort,
        'showGrouping': value.showGrouping,
        'showPrint': value.showPrint,
        'showPagination': value.showPagination,
        'showAbc': value.showAbc,
        'showStichworte': value.showStichworte,
        'showDelete': value.showDelete,
        'showAuswertung': value.showAuswertung,
        'showMailversand': value.showMailversand,
        'showWertSetzen': value.showWertSetzen,
        'showFavorites': value.showFavorites,
    };
}

